






import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, NewObjectLocatableMixin } from "./mixins";
import SingleLinePropertyEditor from "./SingleLinePropertyEditor.vue";

@Component({
  components: {
    propertyEditor: SingleLinePropertyEditor,
  },
})
export default class NewPolylinePropertyEditor extends Mixins(PropertyEditableMixin, NewObjectLocatableMixin) {
  async created(): Promise<void> {
    this.editingSource = await this.createSource();
    this.process = this.layoutPoints;
  }
}
